export enum Align {
  LEFT,
  CENTER,
  RIGHT,
}